import { Button } from '@/src/components/Commons/Button';
import { FundWithDetailsEntity } from '@/src/lib/MayzSmartDB';
import { ActionType, useHomeStore } from '@/src/store';
import { IconCircleDashedLetterI, IconCircleDashedPlus } from '@tabler/icons-react';
import { useEffect, useRef, useState } from 'react';
import styles from './MoreDetailsHome.module.scss';
import { isWebsiteDApp } from '@/src/utils/constants';
import { useRouter } from '@/src/store/router/RouterProvider';
import { ROUTES } from '@/src/utils/routes';

type PropsMoreDetails = {
    fund: FundWithDetailsEntity;
};

export default function MoreDetailsHome(props: PropsMoreDetails) {
    const [isMoreDetails, setIsMoreDetails] = useState(false);
    const { fund } = props;
    const moreDetailsRef = useRef<HTMLDivElement>(null);
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const { currentId, setCurrentId, currentAction, setCurrentAction, currentMode, setCurrentMode } = useHomeStore();
    //--------------------------------------
    const handleBtnDetails = async (fund: FundWithDetailsEntity) => {
        router.replace(`${ROUTES.HOME}?action=${currentAction}&mode=Details&id=${fund._DB_id}`,undefined, { shallow: true }).then((success) => {
            // setCurrentId(fund._DB_id);
            // setCurrentMode('Details');
        });
    };
    //--------------------------------------
    const handleClickBtnAction = (type: ActionType, fund: FundWithDetailsEntity) => {
        setIsMoreDetails(false);
        router.replace(`${ROUTES.HOME}?action=${type}&mode=${currentMode}&id=${fund._DB_id}`,undefined, { shallow: true }).then((success) => {
            // setCurrentId(fund._DB_id);
            // setCurrentAction(type);
        });
    };
    //--------------------------------------
    const handleBtnSelectFund = async (fund: FundWithDetailsEntity) => {
        router.replace(`${ROUTES.HOME}?action=${currentAction}&mode=${currentMode}&id=${fund._DB_id}`,undefined, { shallow: true }).then((success) => {
            //         setCurrentId(fund._DB_id);
        });
    };
    //--------------------------------------
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (moreDetailsRef.current && !moreDetailsRef.current.contains(event.target as Node)) {
                setIsMoreDetails(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [moreDetailsRef]);

    return (
        <div className={`${styles.containerMoreDetails}`}>
            {fund._DB_id !== currentId && (
                <Button
                    mode="link"
                    size="small"
                    arrow={false}
                    // disabled={fund._DB_id === currentId}
                    active={fund._DB_id === currentId}
                    onClick={(event?: React.MouseEvent<HTMLButtonElement>) => {
                        event?.stopPropagation();
                        if (fund._DB_id !== currentId) {
                            handleBtnSelectFund(fund);
                        }
                        // if (isMoreDetails === false) setIsMoreDetails(true);
                    }}
                >
                    {/* {fund._DB_id === currentId ? 'SELECTED' : 'SELECT'} */}
                    SELECT
                </Button>
            )}
            <div className={`${styles.moreDetails}`} ref={moreDetailsRef}>
                {!isMoreDetails ? (
                    <IconCircleDashedPlus className={`${styles.icon} ${isMoreDetails ? styles.open : ''}`} onClick={() => setIsMoreDetails(isMoreDetails ? false : true)} />
                ) : (
                    <IconCircleDashedPlus className={`${styles.icon} ${isMoreDetails ? styles.open : ''}`} onClick={() => setIsMoreDetails(isMoreDetails ? false : true)} />
                )}
                {isMoreDetails && (
                    <div className={`${styles.btnGroup} ${isWebsiteDApp ? styles.largeDetails : ''}`}>
                        <Button
                            mode="link"
                            size="small"
                            arrow={false}
                            onClick={(event?: React.MouseEvent<HTMLButtonElement>) => {
                                event?.stopPropagation();
                                handleBtnDetails(fund);
                            }}
                        >
                            FUND DETAILS
                        </Button>
                        <Button
                            mode="link"
                            size="small"
                            active={currentAction === 'Swap' && fund._DB_id === currentId}
                            arrow={false}
                            onClick={(event?: React.MouseEvent<HTMLButtonElement>) => {
                                event?.stopPropagation();
                                handleClickBtnAction('Swap', fund);
                            }}
                        >
                            BUY/SELL
                        </Button>
                        <Button
                            mode="link"
                            size="small"
                            active={currentAction === 'Deposit' && fund._DB_id === currentId}
                            arrow={false}
                            onClick={(event?: React.MouseEvent<HTMLButtonElement>) => {
                                event?.stopPropagation();
                                handleClickBtnAction('Deposit', fund);
                            }}
                        >
                            MINT/REDEEM
                        </Button>
                        {isWebsiteDApp && (
                            <Button
                                mode="link"
                                size="small"
                                active={currentAction === 'Delegate' && fund._DB_id === currentId}
                                arrow={false}
                                onClick={(event?: React.MouseEvent<HTMLButtonElement>) => {
                                    event?.stopPropagation();
                                    handleClickBtnAction('Delegate', fund);
                                }}
                            >
                                STAKE/UNSTAKE
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
